export default __webpack_public_path__ + "static/media/Onboarding1.9bd4851f.gif";